import { Environments, Brands } from '@delta-defense/client-environments';

export function returnValueForBrand<T>(
	config: Record<Brands, T>,
	brand = Environments.getDomainBrand()
): T {
	return config[brand];
}
